interface GoogleIdentityService {
  initialize: (options: {
    client_id: string; nonce: string; auto_select: boolean;
    callback: (response: { credential: string }) => void;
  }) => void;
  renderButton: (element: HTMLElement, options: {
    theme: string; size: string; text: string; width: number;
  }) => void;
  cancel: () => void;
}

declare global {
  interface Window { google?: { accounts: { id: GoogleIdentityService } } }
}

let scriptPromise: Promise<GoogleIdentityService> | null = null;

export function loadGoogleIdentity(): Promise<GoogleIdentityService> {
  if (window.google?.accounts.id) return Promise.resolve(window.google.accounts.id);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise<GoogleIdentityService>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    const fail = () => {
      clearTimeout(timer);
      script.remove();
      reject(new Error('Google sign-in could not load. Try again or use email/password.'));
    };
    const timer = window.setTimeout(fail, 15000);
    script.onload = () => {
      clearTimeout(timer);
      if (window.google?.accounts.id) resolve(window.google.accounts.id);
      else fail();
    };
    script.onerror = fail;
    document.head.append(script);
  }).catch((error: unknown) => { scriptPromise = null; throw error; });
  return scriptPromise;
}
